import { FormattedMessage } from "react-intl";
import { CHILD_COUNT_MAX, IMPORT_FIELD_MAX_CHARS, type ImportFieldError } from "@/lib/import-field-validation";

// Shared inline validation warning for the in-line merge review's free-text person_detail fields
// (the L2 mirror of the genesis L1 sanitizer): over-length, or an invalid email / phone. Rendered
// under the field, neutral field-meta text only — never a red/accent border (neutral-state-signals
// rule). Not role="alert": a blocked save can reveal several at once; the bar carries the single
// assertive cue. Show/hide timing lives in useImportFieldWarning.
export function MergeFieldWarning({ fieldKey, error }: { fieldKey: string; error: ImportFieldError | null }) {
  if (!error) return null;
  return (
    <div className="field-meta mt-0.5 text-ink/55" data-testid="profile-merge-field-warning">
      {error === "too-long" ? (
        <FormattedMessage
          id="profile.merge.field.tooLong"
          defaultMessage="Keep this to {max} characters or fewer."
          values={{ max: IMPORT_FIELD_MAX_CHARS[fieldKey] ?? 0 }}
        />
      ) : error === "invalid-email" ? (
        <FormattedMessage id="profile.merge.field.invalidEmail" defaultMessage="Enter a valid email address." />
      ) : error === "child-count-max" ? (
        <FormattedMessage
          id="profile.merge.field.childCountMax"
          defaultMessage="The number of children cannot exceed {max}."
          values={{ max: CHILD_COUNT_MAX }}
        />
      ) : (
        <FormattedMessage id="profile.merge.field.invalidPhone" defaultMessage="Enter a valid phone number." />
      )}
    </div>
  );
}
